<template>
  <div class="clinic-management-staff">
    <table-page
        :isTable="true"
        :isPagination="false"
        :auto-height="true"
        :table="tableParams"
        :tableData="tableData"
        row-key="doctorId"
    >
      <!-- <template #top>
        <div class="clinic-management-staff-title" style="color:white">
          账号管理
        </div>
      </template> -->

      <template #searchInput>
        <div class="clinic-management-staff-search-add">
          <!-- <el-input
              class="search-input"
              placeholder="姓名/手机"
              prefix-icon="el-icon-search"
              v-model="reqDoctorList.name"
              clearable
              @keyup.enter.native="searchInputChange"
              @input="onStaffSearchInput"
          >
          </el-input> -->
          <el-button type="primary"
                     style=" background-color: rgb(46, 205, 129); border-color: rgb(46, 205, 129); color: white;"
                     @click="openStaffInfoDialog('新增员工信息', 'add')">新增
          </el-button>
        </div>
      </template>

      <template #tableColumn>
        <el-table-column label="姓名" width="140">
          <template slot-scope="scope">
            <div>
              {{ scope.row.doctorName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="性别" width="70">
          <template slot-scope="scope">
            <div>
              {{ scope.row.doctorGender | convertGender }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="角色">
          <template slot-scope="scope">

            <div>
              {{ (scope.row.roleNames || []).join(',') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="账号" width="140">
          <template slot-scope="scope">
            <div>
              {{ scope.row.account }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="电话号码" width="140"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.doctorPhone }}
            </div>
          </template>
        </el-table-column
        >
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <div>
              <el-switch
                  v-model="scope.row.doctorStatus"
                  :active-value="1"
                  :inactive-value="2"

                  @change="switchChange($event, scope)"
              >
              </el-switch>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="230">
          <template slot-scope="scope">
            <div class="operation-btn">
              <el-link type="primary" style="color:rgb(46, 205, 129)"
                       @click="openStaffInfoDialog('查看员工信息', 'look', scope.row)">查看
              </el-link>
              <el-link type="primary" style="color:rgb(46, 205, 129)"
                       @click="openStaffInfoDialog('编辑员工信息', 'edit', scope.row)"> | 编辑
              </el-link>
              <el-link type="primary" style="color:rgb(46, 205, 129)" @click="resetPassword(scope)"> | 重置密码</el-link>
            </div>
          </template>
        </el-table-column>
      </template>
    </table-page>

    <AddStaff
        :title="title"
        :roleList="roleList"
        :currentStatus="currentStatus"
        :dialogStaffVisible.sync="dialogVisible"
        :staffInfo="rowData"
        @commitStaffInfo="commitStaffInfo"
    ></AddStaff>
  </div>
</template>

<script>
import AddStaff from "@/views/setting_manager/staff/AddStaff";

export default {
  name: "index",
  data() {
    return {
      doctorName: "",
      title: "",
      dialogVisible: false,
      currentStatus: "",
      rowData: {},
      tableData: [],
      roleList: [],
      reqDoctorList: {
        name: "",
        pageNum: 1,
        pageSize: 9999
      },
      tableParams: {
        pageNum: 1,
        pageSize: 9999,
        count: 0
      },
      disableAccountTitle: `当前操作将停用【$$】的账号，停用后该员工将无法登录，请确认您的操作！`,
      enableAccountTitle: `当前操作将恢复启用员工【$$】的账号，启用后该员工将正常登录，请确认您的操作！`,
      resetPasswordTitle: `<div class='reset-password-message-content'>当前操作将为【$$】还原为初始密码，请确认您的操作！</div><div>(初始密码：a123456)</div>`,
      staffSearchTimer: null
    };
  },
  computed: {},
  methods: {
    /**
     * 根据data中是否包含doctorId，判断操作为修改，还是新增
     */
    commitStaffInfo(data) {
      if (data.doctorId) {
        this.updateUserInfo(data);
      } else {
        this.addUserInfo(data);
      }
      this.dialogVisible = false;
    },
    searchInputChange() {
      clearTimeout(this.staffSearchTimer);
      this.staffSearchTimer = null;
      this.reqDoctorList.pageNum = 1;
      this.getStaffTableData();
    },
    onStaffSearchInput() {
      clearTimeout(this.staffSearchTimer);
      this.staffSearchTimer = setTimeout(() => {
        this.staffSearchTimer = null;
        this.reqDoctorList.pageNum = 1;
        this.getStaffTableData();
      }, 350);
    },
    openStaffInfoDialog(titleStr, status, data) {
      this.title = titleStr;
      this.currentStatus = status;
      this.rowData = data;
      this.dialogVisible = true;
    },
    /**
     *  el-switch默认在值改变后执行change事件
     *  这里在请求下发前先将值改回来，再请求，如果成功就改变值，否则不改变
     */
    switchChange(val, data) {
      this.tableData[data.$index].doctorStatus = val === 1 ? 2 : 1;
      let title = ``;
      if (val === 1) {
        title = this.enableAccountTitle.replace("$$", data.row.doctorName);
      } else if (val === 2) {
        title = this.disableAccountTitle.replace("$$", data.row.doctorName);
      }
      this.openMessageBox(title, () => {
        this.$http.post(process.env.VUE_APP_API_HOST + "/api/update_user_status", {
          id: data.row.doctorId,
          status: val
        }, {"content-type": "application/json"}).then(() => {
          this.getStaffTableData();
        });
      });
    },
    resetPassword(data) {
      this.openMessageBox(this.resetPasswordTitle.replace("$$", data.row.doctorName), () => {
        this.$http.post(process.env.VUE_APP_API_HOST + "/api/reset_user_pwd", {id: data.row.doctorId}, {"content-type": "application/json"}).then(() => {
          this.getStaffTableData();
        });
      });
    },
    openMessageBox(title, successFnc = () => {
    }) {
      this.$confirm(title, "操作提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        dangerouslyUseHTMLString: true,
        customClass: "reset-password-message-box"
      }).then(() => {
        successFnc();
        this.$message.success("操作成功!");
      });
    },
    getStaffTableData() {
      this.$http.post(process.env.VUE_APP_API_HOST + "/api/get_user_list", { req: this.reqDoctorList }, {"content-type": "application/json"}).then(res => {
        const body = res.data;
        if (!body) return;
        const list = Array.isArray(body.list) ? body.list : (Array.isArray(body.data) ? body.data : []);
        this.tableData = list;
        const total = body.total != null ? body.total : body.total_record;
        this.tableParams.count = total != null ? total : list.length;
      });
    },
    addUserInfo(data) {
      this.$http.post(process.env.VUE_APP_API_HOST + "/api/add_user", data, {"content-type": "application/json"}).then(() => {
        this.getStaffTableData();
      });
    },
    updateUserInfo(data) {
      this.$http.post(process.env.VUE_APP_API_HOST + "/api/update_user", data, {"content-type": "application/json"}).then(() => {
        this.getStaffTableData();
      });
    },
    getroleList() {
      this.roleList = [];
      this.$http.post(process.env.VUE_APP_API_HOST + "/api/get_all_roles", {}, {"content-type": "application/json"}).then(res => {
        if (res.data) {
          this.roleList = res.data.data;
        }
      });
    }
  },
  created() {
  },
  mounted() {
    this.getStaffTableData();
    this.getroleList();
  },
  beforeDestroy() {
    clearTimeout(this.staffSearchTimer);
  },
  filters: {
    convertGender(val) {
      if (val === 1) return "男";
      if (val === 2) return "女";
      return "-";
    }
  },
  components: {
    AddStaff
  }
}
</script>

<style scoped>
.clinic-management-staff /deep/ .el-table {
  color: rgba(255, 255, 255, 0.88);
  background-color: #3c3f4a;
}

.clinic-management-staff /deep/ .el-table__body-wrapper,
.clinic-management-staff /deep/ .el-table__header-wrapper,
.clinic-management-staff /deep/ .el-table__footer-wrapper {
  background-color: #3c3f4a;
}

.clinic-management-staff /deep/ .el-table tr,
.clinic-management-staff /deep/ .el-table th.el-table__cell {
  background-color: #3c3f4a;
}

.clinic-management-staff /deep/ .el-table td.el-table__cell {
  background-color: #3c3f4a;
}

.clinic-management-staff /deep/ .el-table__body tr:hover > td.el-table__cell {
  background-color: #454957 !important;
}

.clinic-management-staff /deep/ .el-table th.el-table__cell {
  border-bottom-color: rgba(255, 255, 255, 0.12);
}

.clinic-management-staff /deep/ .el-table td.el-table__cell {
  border-bottom-color: rgba(255, 255, 255, 0.08);
}

.clinic-management-staff /deep/ .el-table::before {
  background-color: rgba(255, 255, 255, 0.06);
}

.clinic-management-staff /deep/ .el-table__empty-text {
  color: rgba(255, 255, 255, 0.45);
}

.clinic-management-staff {
  padding: 30px 12px 0 30px;
  font-size: 18px;
}

.clinic-management-staff .clinic-management-staff-title {
  margin-bottom: 22px;
}

.clinic-management-staff .clinic-management-staff-search-add {
  display: flex;
  justify-content: right;
  margin-bottom: 22px;
}

.clinic-management-staff .clinic-management-staff-search-add .search-input {
  width: 279px;
}

.el-switch.is-checked /deep/ .el-switch__core {
  border-color: rgb(46, 205, 129);
  background-color: rgb(46, 205, 129);
}
</style>
